// extracted by mini-css-extract-plugin
export default {"label":"OptionsSelect_label__1pEre","optionsSelect":"OptionsSelect_optionsSelect__Bt76X","optionsEntry":"OptionsSelect_optionsEntry__-DATj"};